export const ScreenSize = {
  DESKTOP: 'desktop',
  TABLET: 'tablet',
  MOBILE: 'mobile',
};

export type ScreenSize = (typeof ScreenSize)[keyof typeof ScreenSize];

export type ScreenOrientation = 'portrait' | 'landscape';

export const ScreenWidth = {
  TABLET: 1370,
  MOBILE: 800,
};

export type ScreenWidth = (typeof ScreenWidth)[keyof typeof ScreenWidth];
